import styled from "styled-components";
import { MainCorrect, MainFrame, MainHeadingCapital, MainHeadingColor, MainFrameWrapper,  MainText, MainSection } from "../../../components/01_config/MainStyles";
import { colors } from "../../../components/01_config/Colors";
import { sizes } from "../../../components/01_config/Sizes";

const Wrapper = styled.div`
    margin-top: ${sizes.headerheight};
`

const Header = styled.div`
    position: relative;
    padding: 50px;
    background-color: ${colors.reading};
    color: white;
    font-size: 3rem;
    font-weight: bold;
    text-transform: uppercase;
    @media(max-width: 800px) {
        padding: 30px 0;
        text-align: center;
        font-size: 2rem
    }
`

const TextsSection = styled(MainSection)`
    flex-direction: column;
    scroll-margin-top: ${sizes.headerheight};
    align-items: center;
`

const HeadingColor = styled(MainHeadingColor)`
    width: 100%;
    text-align: center;
`

const FrameWrapper = styled(MainFrameWrapper)`

`

const Frame = styled(MainFrame)`
    display: flex;
    flex-direction: column;
    // max-width: 70vw;
    // width: 800px;
    gap: 15px;
`

const Topic = styled.div`
    text-decoration: underline;
    white-space: pre-wrap;
`

const FrameHeading = styled(MainHeadingCapital)`
    margin: 0 auto;
    color: ${colors.myprogress};
    color: #044AEF;
    font-weight: bold;
    font-size: 1.4rem;
`

const StoryWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`

const Text = styled(MainText)`
    height: 100%;
    white-space: pre-wrap;
    font-size: 1.2rem;
    line-height: 1.5;
`

const Correct = styled(MainCorrect)`
    white-space: pre-wrap;
    color: red;
    font-style: italic;
    font-size: 1rem;
    line-height: 1.5;
`

const TranslateLink = styled.div`
    color: ${colors.myprogress};
    font-weight: bold;
    cursor: pointer;
`

export { Wrapper, Header, TextsSection, HeadingColor, FrameWrapper, Frame, Topic, FrameHeading, StoryWrapper, Text, Correct, TranslateLink }